import React, { ReactNode } from 'react';
import { Flex } from 'antd';
import { Image } from '@packages/utils';
import { Text, Title } from 'components/Base/Typography';
import fileWithParagraphs from 'assets/images/fileWithParagraphs.svg';

export type TEmptyTableStateProps = {
  imgSrc?: string;
  imgWidth?: number;
  title?: string;
  message?: string;
  button?: ReactNode;
};

const EmptyTableState: React.FC<TEmptyTableStateProps> = ({
  imgSrc = fileWithParagraphs,
  imgWidth = 140,
  title,
  message,
  button,
}) => {
  return (
    <Flex justify="center" align="center" vertical gap={18} className="p-10">
      <Image src={imgSrc} height={imgWidth} alt="Empty Table" />
      {title && <Title level={3}>{title}</Title>}
      <Text>{title}</Text>
      {message && <Text>{message}</Text>}
      {button}
    </Flex>
  );
};

export default EmptyTableState;
